import { Lock as LockIcon } from 'lucide-react';
import PlanGate from '../../../../../../components/gating/PlanGate';
import FeatureLocked from '../../../../../../components/gating/FeatureLocked';
import { postTripData } from '../../../../utils/postTripHelpers';

const AutoNotifications = ({
    prefs = {},
    onToggle,
    loading,
    isNotificationsLocked
}) => {
    const presetsList = postTripData.autoNotificationPresets || [];

    return (
        <div className="relative min-h-[480px]">
            <div className={`space-y-4 w-full ${isNotificationsLocked ? 'opacity-70 pointer-events-none select-none' : ''}`}>
                <p className="text-xs text-slate-500 font-medium">
                    These notifications fire automatically based on trip triggers. Toggle off any you do not want to send.
                </p>

                {loading ? (
                    <div className="py-12 flex justify-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#067978]"></div>
                    </div>
                ) : (
                    presetsList.map((preset) => (
                        <div 
                            key={preset.key} 
                            className="bg-white border border-slate-200 rounded-2xl p-5 flex items-center justify-between shadow-sm hover:shadow-xs transition-shadow"
                        >
                            <div className="pr-4">
                                <h4 className="font-bold text-slate-800 text-base">{preset.title}</h4>
                                <p className="text-xs text-slate-500 mt-1">{preset.sub || preset.desc}</p>
                            </div>
                            
                            <PlanGate
                                requiredPlan="growth"
                                featureName="Auto Notifications"
                                tooltipText="Automated triggers require the Growth Plan"
                                showLockIcon={false}
                            >
                                {({ isLocked, onClick }) => (
                                    <button 
                                        type="button"
                                        onClick={isLocked ? onClick : () => onToggle(preset.key)}
                                        className={`w-12 h-6 rounded-full transition-colors relative flex items-center shrink-0 cursor-pointer ${
                                            isLocked
                                                ? 'bg-slate-200 hover:bg-slate-300'
                                                : prefs?.[preset.key]?.enabled ? 'bg-[#067978]' : 'bg-slate-200'
                                        }`}
                                        title={isLocked ? 'Upgrade to Growth Plan to enable auto notifications' : undefined}
                                    >
                                        <span className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-transform shadow-xs flex items-center justify-center ${
                                            !isLocked && prefs?.[preset.key]?.enabled ? 'right-0.5' : 'left-0.5'
                                        }`}>
                                            {isLocked && <LockIcon size={10} className="text-slate-500" />}
                                        </span>
                                    </button>
                                )}
                            </PlanGate>
                        </div>
                    ))
                )}
            </div>

            {isNotificationsLocked && (
                <FeatureLocked featureKey="notifications" overlay={true} />
            )}
        </div>
    );
};

export default AutoNotifications;
